var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[(_vm.loading)?_c('div',[_vm._v("Загружаю...")]):_c('DriverForm',{attrs:{"driver":_vm.driver,"displayDeleteBtn":_vm.$store.getters.hasPermission('driver:delete')},on:{"cancel":_vm.cancel,"submit":_vm.submit,"delete":_vm.deleteHandler}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }